// import plugins from libraries here
import DevicesUnderUserRoute from './DevicesUnderUserRoute';
import SearchUsersLink from './SearchUsersLink';
import SearchUsersRouter from './SearchUsersRoute';
const install = molten => {
  molten.addPlugin('Route', DevicesUnderUserRoute);
  molten.addPlugin('Action', SearchUsersLink);
  molten.addPlugin('Route', SearchUsersRouter);
};
export default {
  install
};